<template>
  <div id="app">
    <b-loading :is-full-page="true" v-model="loading"></b-loading>
    <template v-if="!loading">
      <RankingBlock />
      <div class="responsive-chart">
        <BarChart2 />
        <RadarChart :height="600" />
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex";
import BarChart2 from "@/components/BarChart2";
import RadarChart from "@/components/RadarChart";
import RankingBlock from "@/components/RankingBlock";

export default {
  name: "App",
  components: {
    BarChart2,
    RadarChart,
    RankingBlock,
  },
  data() {
    return {
      chartOptions: {
        responsive: true,
      },
    };
  },
  mounted() {
    this.$store.dispatch("fetchData");
  },
  computed: {
    ...mapState(["loading"]),
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.responsive-chart {
  position: relative;
  width: 100%;
  height: auto;
}
</style>
